/**
 * persistenceGuards.js — Safe validation helpers for runtime snapshots.
 *
 * All functions are pure and synchronous — no side effects.
 */

import { SCHEMA_VERSION, TTL_MS, MAX_SIZE_BYTES } from "./persistenceSchema";

/** Returns true if `data` has the expected snapshot shape. */
export function isValidSnapshot(data) {
  return (
    data !== null &&
    typeof data === "object" &&
    data._schema === SCHEMA_VERSION &&
    typeof data._timestamp === "number" &&
    !Number.isNaN(data._timestamp)
  );
}

/** Returns true if the snapshot has passed its TTL. */
export function isExpired(snapshot) {
  return Date.now() - snapshot._timestamp > TTL_MS;
}

/** Returns true if the serialized JSON string is within the size budget. */
export function isSafeSize(json) {
  try {
    return new Blob([json]).size <= MAX_SIZE_BYTES;
  } catch {
    return json.length <= MAX_SIZE_BYTES;
  }
}

/** Safe JSON.parse — returns null on any error. */
export function safeParseJSON(str) {
  try { return JSON.parse(str); }
  catch { return null; }
}
